module.exports = "https://static.weeecdn.net/mweb/_next/static/images/annual_bg-77743db05c4c266642b0d9053f506a40.png";